import { useSyncExternalStore, type ReactNode } from 'react';

// Ambient publish/subscribe for the topbar's title + right-aligned
// actions slot. Pages publish with `<Shell title="X">` (or directly
// via `setShellFrame`); only the TopBar subscribes. Keeping the
// subscriber count to one avoids re-rendering AppLayout / Outlet /
// pages when a new title or fresh actions node arrives.
export type ShellFrame = {
  title?: string | undefined;
  actions?: ReactNode | undefined;
};

let current: ShellFrame = {};
const listeners = new Set<() => void>();

export function setShellFrame(next: ShellFrame): void {
  if (current.title === next.title && current.actions === next.actions) return;
  current = next;
  listeners.forEach((l) => l());
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

function getSnapshot(): ShellFrame {
  return current;
}

export function useShellFrame(): ShellFrame {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
